// Types
import type { TSearchPerformer } from '~/misc/location/autocomplete/types';
import type { ILocationSearchResult } from '~/misc/location/search/types';
import { ESearchResultType } from '~/misc/location/search/types';

// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerLocationSearchModel } from '~/modules/manager/location/search/models/location-search.model';

export class ManagerLocationSearchDataClient
  extends AbstractDataClient<ManagerLocationSearchModel>
  implements TSearchPerformer
{
  constructor(protected include?: ESearchResultType[]) {
    super(new ManagerLocationSearchModel());
  }

  public searchByQuery(query: string): Promise<ILocationSearchResult[]> {
    return this.request('search', query, this.include);
  }
}
